export enum WREX_GENERATED_CONTENT {
    /**
     * @value AI editor toolbar
     */
    AI_EDITOR_TOOLBAR_LABEL = 'WREX_AI.AI_EDITOR_TOOLBAR_LABEL',
    /**
     * @value Generating result...
     */
    GENERATING_RESULT = 'WREX_AI.GENERATING_RESULT',
    /**
     * @value Or give a task to AI...
     */
    GIVE_A_TASK = 'WREX_AI.GIVE_A_TASK',
    /**
     * @value Ignore
     */
    IGNORE_SUGGESTION = 'WREX_AI.IGNORE_SUGGESTION',
    /**
     * @value Lengthen
     */
    MENU_REFINE_LENGTHEN = 'WREX_AI.MENU_REFINE_LENGTHEN',
    /**
     * @value Shorten
     */
    MENU_REFINE_SHORTEN = 'WREX_AI.MENU_REFINE_SHORTEN',
    /**
     * @value Refine style
     */
    MENU_REFINE_STYLE = 'WREX_AI.MENU_REFINE_STYLE',
    /**
     * @value Change tone
     */
    MENU_REFINE_TONE = 'WREX_AI.MENU_REFINE_TONE',
    /**
     * @value Modify or review selection
     */
    MODIFY_SELECTION_SECTION = 'WREX_AI.MENU_MODIFY_SELECTION',
    /**
     * @value Or ask anything...
     * @description Text to indicate to the user he can ask something to the AI in an input
     */
    OR_ASK_ANYTHING = 'AI.OR_ASK_ANYTHING',
    /**
     * @value Replace selection
     */
    REPLACE_SELECTION = 'WREX_AI.REPLACE_SELECTION',
    /**
     * @value Revise selection
     * @description Revise selected text using AI
     */
    REVISE_SELECTION = 'AI.REVISE_SELECTION',
}
